// eslint-disable-next-line no-control-regex
const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\x00-\x1f]/;

const MAX_NAME_LENGTH = 100;

export const TEMPLATE_NAME_ERRORS = {
  TOO_LONG: `Template name must be ${MAX_NAME_LENGTH} characters or fewer`,
  INVALID_CHARS: 'Name must not have invalid characters (<, >, :, ", /, \\, |, ?, *)',
  NOT_UNIQUE: "Name already taken. Enter a unique name.",
} as const;

export const hasInvalidFilenameChars = (value: string): boolean =>
  INVALID_FILENAME_CHARS.test(value);

export const getTemplateNameError = (
  name: string,
  existingNames: Set<string>,
  currentName?: string,
): string | undefined => {
  const trimmed = name.trim();
  if (trimmed.length > MAX_NAME_LENGTH) return TEMPLATE_NAME_ERRORS.TOO_LONG;
  if (hasInvalidFilenameChars(trimmed)) return TEMPLATE_NAME_ERRORS.INVALID_CHARS;
  if (existingNames.has(trimmed) && trimmed !== currentName)
    return TEMPLATE_NAME_ERRORS.NOT_UNIQUE;
  return undefined;
};
